// extracted by extract-css-chunks-webpack-plugin
module.exports = {"top_ad":"top_ad-pTeobkU7","main":"main-1lBQVsCL","passAd":"passAd-rJ7_0-kY","footer_ad":"footer_ad-1YgF1H1m"};